import React, { useState } from "react";
import styled from "styled-components";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { apiClient } from "../../App";
import { History } from "history";

interface Props {
  history: History;
}

const StyledStartRecording = styled.div`
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    color: ${props => props.theme.colors.black};
    background: white;
    padding: 2rem 1.5rem;
    max-width: 600px;
    border-radius: 1.5rem;
  }

  input {
    margin-bottom: 1.5rem;
  }
`;

const StartRecording: React.FC<Props> = props => {
  const [query, setQuery] = useState("");

  const startRecording = async () => {
    try {
      const { data: recording } = await apiClient.post("/recording", {
        query
      });

      props.history.push(`/recording/${recording.id}`);
    } catch (err) {
      console.log(err);
      alert("Failed to start recording");
    }
  };

  return (
    <StyledStartRecording>
      <div>
        <h2>Start recording</h2>
        <p>Enter subject or username of messages that will be recorded. Will by default record all messages.</p>
        <Input
          placeholder="For example http.get.* or bob@frost.se"
          onChange={(e: any) => setQuery(e.target.value)}
          value={query}
          inputSize="l"
        />
        <Button title="Start" onClick={startRecording} />
      </div>
    </StyledStartRecording>
  );
};

export default StartRecording;
